import React, { Suspense,useEffect } from 'react';

//import './App.css';
import SiteRouting from './routing/SiteRouting';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from "react-auth-kit";
import { Provider } from 'react-redux';
import store from './redux/ConfigureStore';
import loadingImg from './assets/images/wdLoading.gif';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import '@splidejs/splide/dist/css/splide.min.css';

function App() {

  return (
    // <Suspense fallback={<div style={{ minHeight: 'calc(100vh - 32px)' }} className="flex items-center justify-center h-full"><img className="py-1.5" src={loadingImg} alt="western digital" /></div>}>
      <Provider store={store}>
        <Header />
        <div style={{ minHeight: 'calc(100vh - 32px)' }}>
          <AuthProvider
            authCookieName={"cookie"}
            authTimeCookieName={"timecookie"}
            stateCookieName={"statecookie"}
            authType={'statecookie'}
            authName={'_auth'}
            cookieDomain={window.location.hostname}
            cookieSecure={window.location.protocol === "http:"}>
            <BrowserRouter>
              <SiteRouting />
            </BrowserRouter>
          </AuthProvider>
        </div>
        <Footer />
      </Provider>
    // </Suspense>
  );
}

export default App;

